














































































































import {Component, Prop} from "vue-property-decorator"
import AbpBase from "@/lib/abpbase"
import {
    GetMachineList,
    GetManufacturerList, InsertMachineMaintenance,
    InsertMachineRepair, InsertMachineScrap,
    UpdateMachineMaintenance,
    UpdateMachineRepair, UpdateMachineScrap
} from "@/api/machines"
import {QuerySysDic} from "@/api/material"
import myTable from '../../../../components/table/my-table.vue'

@Component({
    components: {myTable}
})
export default class Repair extends AbpBase {
    @Prop() data: any
    @Prop() title: any
    @Prop({type: Boolean, default: false}) value: boolean
    @Prop({type: Array, default: []}) tenants: []
    form: any = {
        "machineId": null,
        "machineName": "",
        "machineTypeId": null,
        "machineNo": "",
        "maintenanceMeasuresId": null,
        "maintenanceMeasures": "",
        "repairManufacturerId": null,
        "repairManufacturer": "",
        "maintenanceCost": 0,
        "repairResultId": "",
        "repairResult": "",
        "sourceName": "",
        "dialysisCenter": null,
        "scrapInfo": "",
        "manufacturer": "",
        "source": null,
        "tenantId": null,
        "status": true,
        "machineModel": '',
        "tenantName": '',
    }
    machines: any[] = []
    repairManufacturerIds: any[] = []
    repairResultIds: any[] = []
    reasons: any[] = []
    repairManufacturerLoading = false

    cancel() {
        this.$emit('input', false);
    }

    created() {
        this.getSelects()
        if (this.title === '编辑') {
            this.form = Object.assign({}, this.data)
            this.machineChange()
        }
    }

    list: any[] = []

    deleteOne(scope: any) {
        this.list.splice(scope.$index, 1)
    }

    machineChange() {
        this.machines.forEach((item: any) => {
            if (item.id === this.form.machineId) {
                this.form.machineModel = item.machineModel
                this.form.machineName = item.machineName
                this.form.source = item.source
                this.form.machineTypeId = item.machineTypeId
                this.form.manufacturer = item.manufacturer
            }
        })
    }

    repairManufacturerChange() {
        this.repairManufacturerIds.forEach((item: any) => {
            if (item.id === this.form.repairManufacturerId) {
                this.form.repairManufacturer = item.manufacturerName
            }
        })
    }

    tenantChange() {
        this.form.dialysisCenter = this.form.tenantId
        this.tenants.forEach((item: any) => {
            if (item.value === this.form.tenantId) {
                this.form.tenantName = item.text
            }
        })
    }

    add() {
        (this.$refs.form as any).validate(valid => {
            if (valid) {
                this.list.push(this.form)
                this.form = {}
            } else {
                return false;
            }
        });

    }

    async save() {
        let res
        if (this.title === "新增") {
            if (!this.list.length) {
                this.$message.error("请添加维修详情！")
                return
            }
            res = await InsertMachineScrap(this.list)
        } else {
            res = await UpdateMachineScrap(this.form)
        }
        if (res.code === 2000) {
            this.$emit('save-success', false)
        }
    }

    private getSelects() {
        this.getMachines()
        this.getMaintenanceMeasuresIds()
        this.getRepairManufacturerIds()
        this.getRepairResultIds()
    }

    async getMachines() {
        let res = await GetMachineList({status: true, page: 1, pageSize: 10})
        this.machines = res.items
    }

    async getMaintenanceMeasuresIds() {
        let res = await QuerySysDic({dataType: 4, status: true, typeName: ""})
        this.reasons = res.data
    }

    async getRepairManufacturerIds(queryString: string = '') {
        this.repairManufacturerLoading = true
        let res = await GetManufacturerList({manufacturerName: queryString, status: true, page: 1, pageSize: 10000})
        this.repairManufacturerIds = res.items
        this.repairManufacturerLoading = false
    }

    async getRepairResultIds() {
        let res = await QuerySysDic({dataType: 5, status: true, typeName: ""})
        this.repairResultIds = res.data
    }

    rules = {
        machineId: {required: true, message: '请选择设备', trigger: 'blur'},
        tenantId: {required: true, message: '请选择中心', trigger: 'blur'},
        scrapInfo: {required: true, message: '请输入', trigger: 'blur'},
        person: {required: true, message: '请输入', trigger: 'blur'},
        maintenanceCost: {
            required: true,
            validator: (rule, value, callback) => {
                if (value <= 0) {
                    callback(new Error("请填写正确的金额！"));
                } else {
                    callback();
                }
            },
        },
        repairResultId: {required: true, type: 'number', message: '请输入', trigger: 'blur'},
        maintenanceMeasuresId: {required: true, message: '请选择', trigger: 'blur'},
        repairManufacturerId: {required: true, message: '请选择', trigger: 'blur'},
        scrapUser: {required: true, message: '请选择', trigger: 'blur'},
        scrapDate: {required: true, message: '请选择', trigger: 'blur'},
    }
}
